import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";

// Third-party modules
import { AngularFireModule, FirebaseAppConfig } from "angularfire2";
import { AngularFireAuthModule } from "angularfire2/auth";
import { AngularFireDatabaseModule } from "angularfire2/database";

// shared modules
import { SharedModule } from "../auth/shared/shared.module";
import { AuthFormComponent } from "./shared/components/auth-form/auth-form.component";

export const ROUTES: Routes = [
  {
    path: "auth",
    children: [
      { path: "", pathMatch: "full", redirectTo: "login" },
      { path: "login", loadChildren: "./login/login.module#LoginModule" },
      {
        path: "register",
        loadChildren: "./register/register.module#RegisterModule"
      }
    ]
  }
];

export const firebaseConfig: FirebaseAppConfig = {
  apiKey: "AIzaSyCBoO8qtU74xzdHOjAtcClMoGZLKbIp3_I",
  authDomain: "spellbook-bb5d3.firebaseapp.com",
  databaseURL: "https://spellbook-bb5d3.firebaseio.com",
  projectId: "spellbook-bb5d3",
  storageBucket: "spellbook-bb5d3.appspot.com",
  messagingSenderId: "583306281311"
};

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    SharedModule.forRoot()
  ],
  declarations: [],
  providers: []
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/auth/auth.module.ts